import { useState, useEffect } from 'react';
import { Eye, Download } from 'lucide-react';
import { getAdminApplications, downloadResume } from '../../services/api';

export default function AdminApplications() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getAdminApplications().then(res => { setApps(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <>
      <div className="admin-table-wrap">
        <div className="admin-table-header">
          <h2>Job Applications ({apps.length})</h2>
        </div>
        {apps.length === 0 ? (
          <div className="empty-state"><h3>No applications received yet</h3><p>Applications will appear here when candidates apply</p></div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr><th>Name</th><th>Email</th><th>Phone</th><th>Job</th><th>Date</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {apps.map(app => (
                <tr key={app.id}>
                  <td style={{ fontWeight: 600 }}>{app.name}</td>
                  <td>{app.email}</td>
                  <td>{app.phone}</td>
                  <td>{app.jobTitle}</td>
                  <td>{new Date(app.createdAt).toLocaleDateString()}</td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => setSelected(app)}><Eye size={14} /> View</button>
                      {app.resumePath && (
                        <a href={downloadResume(app.resumePath)} className="table-actions"
                          style={{ display: 'inline-flex' }} target="_blank" rel="noreferrer">
                          <button className="btn-download"><Download size={14} /> Resume</button>
                        </a>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Application Details</h2>
            <div style={{ display: 'grid', gap: 16 }}>
              <div><strong>Name:</strong> {selected.name}</div>
              <div><strong>Email:</strong> {selected.email}</div>
              <div><strong>Phone:</strong> {selected.phone}</div>
              <div><strong>Applied for:</strong> {selected.jobTitle}</div>
              <div><strong>Date:</strong> {new Date(selected.createdAt).toLocaleString()}</div>
              {selected.coverLetter && (
                <div>
                  <strong>Cover Letter:</strong>
                  <p style={{ marginTop: 8, color: '#475569', lineHeight: 1.7, background: '#f8fafc', padding: 16, borderRadius: 8 }}>
                    {selected.coverLetter}
                  </p>
                </div>
              )}
              {selected.resumePath && (
                <div>
                  <strong>Resume:</strong>{' '}
                  <a href={downloadResume(selected.resumePath)} target="_blank" rel="noreferrer"
                    style={{ color: '#2563eb', fontWeight: 600 }}>
                    Download {selected.resumeOriginalName}
                  </a>
                </div>
              )}
            </div>
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setSelected(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
